

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import moment from "moment";

const initialState = {

    //! bu title ların 
    aiChatTitles: [],

    isLoadingGetAiChatTitles: false,

    //! bu da bir chat in içeriği
    aiChatContent: {
        createdAt: null,
        creatorUserId: null,
        chatId: null
    },

    messageList: [],
    isLoadingGetAiChatMessagesById: false,


    //! kullanıcın mevcut mesajı
    initUserMessage: "",

    //! ai nin mevcut mesajı
    initAiMessage: "",

    aiRemainingUsage: null,


    isLoadingGetPanelAiChatsHistory: false,
    panelAiChatsHistory: [],
    panelAiChatsHistoryCount: null,

    singleAiChatAllMessages: null,

    isLoadingUpdateAiChat: false

}

export const getAiChatTitles = createAsyncThunk("ai/getAiChatTitles", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/AiChat/GetList`)
        return data.values.$values
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getAiChatMessagesById = createAsyncThunk("ai/getAiChatMessagesById", async(chatId, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/AiChat/GetById?getByAiChatId=${chatId}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateAiChat = createAsyncThunk("ai/UpdateAiChat", async(body, thunkApi)=> {
    
    try {
        
        const {data} = await axiosInstance.post(`/Ai/OpenAIChat`, body)
        
        thunkApi.dispatch(getTodaysTotalAiMessageCount())
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getTodaysTotalAiMessageCount = createAsyncThunk("ai/getTodaysTotalAiMessageCount", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/AiChat/GetTodaysTotalAiMessageCount`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})



  //! panel ai chats history
  export const getPanelAiChatsHistory = createAsyncThunk("ai/getPanelAiChatsHistory",async ({currentPage}, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/AiChat/GetAllAiChats?page=${currentPage}&&size=${20}`);
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  

const aiSlice = createSlice({
    name: "ai",
    initialState,
    reducers: {

        //! bu kullanıcının ai ye gönderdiği mesaj
        setInitUserMessage:(state, action) => {
            state.initUserMessage = action.payload 
        },

        setInitAiMessage: (state, action) => {
            state.initAiMessage = state.initAiMessage += action.payload
        },

        setNewAiChat: (state) => {
            state.isAiResponseOver = false
            state.aiChatContent = {
                createdAt: null,
                creatorUserId: null,
                chatId: null
            }
            state.initAiMessage = ""
            state.initUserMessage = ""
            state.messageList = []
        },

        getSingleAiChatAllMessages: (state, action) => {
            state.singleAiChatAllMessages = action.payload
        }

    },
    extraReducers:(builder)=> {
        builder

            //! getAiChatTitles
            .addCase(getAiChatTitles.pending, (state)=> {
                state.isLoadingGetAiChatTitles = true 
            })
            
            .addCase(getAiChatTitles.fulfilled, (state, action)=> {
                state.isLoadingGetAiChatTitles = false 
                state.aiChatTitles = action.payload 
            })

            .addCase(getAiChatTitles.rejected, (state)=> {
                state.isLoadingGetAiChatTitles = false 
            })


            //! getAiChatMessagesById
            .addCase(getAiChatMessagesById.pending, (state)=> {
                state.isLoadingGetAiChatMessagesById = true 
            })
            
            .addCase(getAiChatMessagesById.fulfilled, (state, action)=> {
                state.isLoadingGetAiChatMessagesById = false 
                state.isAiResponseOver = false
                state.initAiMessage = ""
                state.initUserMessage = ""
                state.messageList = action.payload.aiChatMessages.$values.map(item => {
                    return {
                        ...item,
                        isFromApi: true
                    }
                }) 
                state.aiChatContent = {
                    createdAt: action.payload.createdAt,
                    creatorUserId: action.payload.creatorUserId,
                    chatId: action.payload.id 
                } 
            })

            .addCase(getAiChatMessagesById.rejected, (state)=> {
                state.isLoadingGetAiChatMessagesById = false 
            })


            //! updateAiChat
            .addCase(updateAiChat.pending, (state)=> {
                state.isLoadingUpdateAiChat = true
            })
            
            .addCase(updateAiChat.fulfilled, (state, action)=> {
                state.isLoadingUpdateAiChat = true
                state.initAiMessage = ""
                state.initUserMessage = ""
                state.isAiResponseOver = false


                if(!state.aiChatTitles.find(item => item.id === action.payload.updateChatId)){
                    state.aiChatTitles = [
                        ...state.aiChatTitles,
                        {
                            id: action.payload.updateChatId,
                            title: action.payload.userMessage.message,
                            createdAt: new Date().toISOString().slice(0, -1)
                        }
                    ]
                    state.aiChatContent = {
                        chatId: action.payload.updateChatId,
                        title: action.payload.userMessage.message,
                        createdAt: new Date().toISOString().slice(0, -1),
                    }

                    state.messageList = [
                        action.payload.userMessage,
                        action.payload.aiMessage
                    ]
                }

                else if((state.aiChatContent.chatId === action.payload.updateChatId) && state.messageList.length > 0){
                    state.messageList = [
                        ...state.messageList,
                        action.payload.userMessage,
                        action.payload.aiMessage 
                    ]
                }

            })

            .addCase(updateAiChat.rejected, (state)=> {
                state.isLoadingUpdateAiChat = true
            })


            //! getTodaysTotalAiMessageCount
            .addCase(getTodaysTotalAiMessageCount.pending, (state)=> {
            })
            
            .addCase(getTodaysTotalAiMessageCount.fulfilled, (state, action)=> {
                state.aiRemainingUsage = (action.payload.userTotalMessageCharacterCount < 2500) && (action.payload.userTotalMessageCount < 36)
            })

            .addCase(getTodaysTotalAiMessageCount.rejected, (state)=> {
            })


            //! getPanelAiChatsHistory
            .addCase(getPanelAiChatsHistory.pending, (state)=> {
                state.isLoadingGetPanelAiChatsHistory = true
            })
            
            .addCase(getPanelAiChatsHistory.fulfilled, (state, action)=> {
                const messageHistoryByDate = action.payload.values.$values.reduce((acc, message) => {
                    const { createdAt, ...restOfMessage } = message;
                    const group = acc.find(
                        (item) => moment(item.createdAt).format('L') === moment(createdAt).format('L')
                    );
                    if (!group) {
                        acc.push({
                            createdAt: createdAt,
                            data: [restOfMessage],
                        });
                    } else {
                        group.data.push(restOfMessage);
                    }
                    return acc?.sort((a, b) => moment(b?.createdAt) - moment(a?.createdAt));
                }, []);

                state.panelAiChatsHistory = messageHistoryByDate
                state.isLoadingGetPanelAiChatsHistory = false
                state.panelAiChatsHistoryCount = action.payload.totalCount

            })

            .addCase(getPanelAiChatsHistory.rejected, (state)=> {
                state.isLoadingGetPanelAiChatsHistory = false
            })
            

            
            
            
    }
})


export const {
    setInitUserMessage,
    setInitAiMessage,
    setNewAiChat,
    getSingleAiChatAllMessages
} = aiSlice.actions
export default aiSlice.reducer